var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPaymentDefault = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4A606A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.791 10.527V9.34c0-1.353-1.157-2.464-2.603-2.464H5.658c-1.43 0-2.603 1.095-2.603 2.464v1.187c0 .122.097.213.225.213h23.27c.129 0 .241-.091.241-.213zM3.055 12.617v7.728c0 1.395 1.156 2.539 2.602 2.539H24.19c1.429 0 2.601-1.129 2.601-2.54v-7.727a.217.217 0 0 0-.225-.22H3.28c-.128-.015-.225.095-.225.22zm5.926 5.925a.738.738 0 0 1-.739.721h-.738a.738.738 0 0 1-.739-.72v-.722c0-.392.337-.721.739-.721h.738c.402 0 .74.33.74.721v.721z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPaymentDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-payment-default.2e79d6f9b91b47fdd8cd17edf6bd379e.svg";